import React, { useEffect, useState } from "react";
import {
  DatePicker,
  Button,
  Skeleton,
  Table,
  Result,
  Checkbox,
  ConfigProvider,
  message,
} from "antd";

import { useSelector } from "react-redux";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import { FilterOutlined } from "@ant-design/icons";
const { RangePicker } = DatePicker;
const MAX_DAYS = 30;
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import customParseFormat from "dayjs/plugin/customParseFormat";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
// import minnotra_logo from "../../../../../Assets/Images/logo2.png";
import minnotra_logo from "../../../Assets/Images/logo2.png";
import { formatDateTime, generatedISOFormatDateString, getLastDayTimeRangeIST } from "../../../Utils/DateConverstion";
import { useStoreUpdaterWithAPI } from "../../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../../Common/APIConstants";
import Empty from "../../CommonScreens/Empty";
import CustomDrawer from "../../../components/Elements/CustomDrawer";
import CustomSelect from "../../../components/Elements/CustomSelect";
import SteamTreeSelectCustomWithSelectAll from "../../../components/Screens/Electrical/Charts/LiveModule/LiveTrends/LineChart/TreeSelectCustomWithAllSelect";
import TableComponentReport from "../../../components/Elements/Grid/TableComponentReport";
import TableComponentShiftReport from "../Electrical/Charts/LiveModule/LiveTrends/LineChart/TableComponentShiftReport";



// Extend plugins
dayjs.extend(weekday);
dayjs.extend(weekOfYear);
dayjs.extend(customParseFormat);
 
const ShiftReportFlow = () => {
  const { loading, makeRequest } = useStoreUpdaterWithAPI();
  const [sectionId, setSectionId] = useState(1);
  const [converterId, setConverterId] = useState(2);
  const [report, setReport] = useState([]);
    const [selectedMeterIds, setSelectedMeterIds] = useState(["8","9","10"]);
     const [selectedValues, setSelectedValues] = useState(["Cumulative"]);
     const [tempDates, setTempDates] = useState([]);
  const [skip, setSkip] = useState(true);
  const [open, setOpen] = useState(false);
  const [chartSkip, setChartSkip] = useState();
  const [chartConverterInput, setChartConverterInput] = useState();
  const [chartGroupInput, setChartGroupInput] = useState();
  const [submit, setSubmit] = useState(false);
  // const [loading, setLoading] = useState(false);
  const [converterGroupId, setConverterGroupId] = useState("1");
  const [sectionError, setSectionError] = useState();
  const [converterError, setConverterError] = useState();
  const [fromDateError, setFromDateError] = useState();
  const [toDateError, setToDateError] = useState();
  const [paraError, setParaError] = useState();
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 100,
    },
  });

  const [flowSectionResData, setflowSectionResData] = useState([]);
  const [getFlowConverterResData, setgetFlowConverterResData] = useState([]);
  const [flowGroupDetailsResData, setflowGroupDetailsResData] = useState([]);
    const [meterError, setMeterError] = useState();

  const [nsGetFlowConverterResData, setnsGetFlowConverterResData] = useState(
    []
  );
  const [getFlowSteamGroupMeterResData, setgetFlowSteamGroupMeterResData] =
    useState([]);

       const[getElectricGroupMeterList,setGetElectricGroupMeterList]=useState([])
   const[nsGetElectricConverterMeterList,setNsGetElectricConverterMeterList]=useState([])
  const [consumptionData, setConsumptionData] = useState([]);
  const [loadings, setLoadings] = useState(true);

  const [checkedValue, setCheckedValue] = useState(null);
  const [isLast24Hours, setIsLast24Hours] = useState(false);
  const [time, setTime] = useState(false);
  const [to, setTo] = useState(null);
  const [from, setFrom] = useState(null);
  const [datesError, setDatesError] = useState(null);
  const [excelToDate, setExcelToDate] = useState(null);
  const [excelFromDate, setExcelFromDate] = useState(null);
  const [showCalendar, setShowCalendar] = useState(false);
    const [parameter, setParameter] = useState([]);
  const [value, setValue] = useState([dayjs().subtract(1, "day").startOf("day"),dayjs().startOf("day")]);
    const [fromDateObj, setFromDateObj] = useState(dayjs().subtract(1, "day").startOf("day").format("YYYY-MM-DD HH:mm:ss"));
    const [fromDateString, setFromDateString] = useState(dayjs().subtract(1, "day").startOf("day").format("YYYY-MM-DD HH:mm:ss"));
    const [toDateObj, setToDateObj] = useState(dayjs().startOf("day").format("YYYY-MM-DD HH:mm:ss"));
    const [toDateString, setToDateString] = useState(dayjs().startOf("day").format("YYYY-MM-DD HH:mm:ss"));
    const [excelImage, setExcelImage] = useState(null);
   const loggedIn = useSelector((state) => state.user);
     const [module,setModule]=useState()
       const [defaultLoad, setDefaultLoad] = useState(true)
     
  // console.log(loggedIn)

  const [shiftTimings,setShiftTimings]=useState([])
  const [shift,setShift]=useState(1)
    const [moduleList,setModuleList]=useState([])


    useEffect(() => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.FLOW_GET_PARAMETERS.replace("MdType",module??4)}`,
    }).then((res) => {
      
      if (res && res.length > 0) {
      setParameter(res);
      }
    });
  }, [module]);
  useEffect(() => {
    if (sectionId == 1 && module) {
      makeRequest({
        type: APIConstants.GET,
        url: module == 3 ? `${APIConstants.TEMP_CONVERTERS}?ModuleType=${module}` : `${APIConstants.FLOW_CONVERTERS}?ModuleType=${module}`,
      }).then((res) => {
        // //console.log(res);
        if (res && res.length > 0) {
          setgetFlowConverterResData(res);
          if (defaultLoad) {
            setConverterId(res[0]?.sitE_ID)
          }

        }
      });
    }
    if (sectionId == 2) {
      makeRequest({
        type: APIConstants.POST,
        url: `${APIConstants.ELECTRICAL_GROUP_NAME}?Module=1`,
      }).then((res) => {
        // //console.log(res);
        if (res && res.length > 0) {
          setgetFlowConverterResData(res);
        }
      });
    }
  }, [sectionId, module]);

  useEffect(()=>{

    setExcelImage(loggedIn?.images?.excelImage?`data:image/png;base64,${loggedIn?.images?.excelImage}`:null);
  },[loggedIn])
    useEffect(() => {
    makeRequest({
         type: APIConstants.GET,
         // GetFlowSteamGropeMeterDetails?GroupID=81
         url: `${APIConstants.FLOW_MODULES}`,
       }).then((res) => {
         console.log(res);
         if (res && res.length > 0) {
           setModuleList(res); 
           setModule(res[0].moduleId)
         }
       });   
  }, []);
  useEffect(() => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_FLOW_SECTION_MASTER_DETAILS}`,
    }).then((res) => {
      //console.log(res);
      if (res && res.length > 0) {
        setflowSectionResData(res);
      }
    });
 
  }, []);
  //  useEffect(()=>{
  //    makeRequest({ 
  //        type: APIConstants.GET, 
  //        // GetFlowSteamGropeMeterDetails?GroupID=81
  //        url: `${APIConstants.GET_FLOW_SECTION_MASTER_DETAILS}`
  //        //  url: `${APIConstants.GET_FLOW_SECTION_MASTER_DETAILS_WATER}`
  //      }).then((res) => {
  //        console.log(res)
  //        setflowSectionResData(res);
  //      });
 
  //    makeRequest({ 
  //        type: APIConstants.GET, 
  //        // GetFlowSteamGropeMeterDetails?GroupID=81
  //        url: `${APIConstants.GET_FLOW_CONVERTER_DETAILS}`
  //        //  url: `${APIConstants.GET_CONVERTER_DETAILS_WATER}`
  //      }).then((res) => {
  //        console.log(res)
  //        setgetFlowConverterResData(res);
  //      });
 
  //    makeRequest({  
  //        type: APIConstants.GET, 
  //        // GetFlowSteamGropeMeterDetails?GroupID=81
  //        url: `${APIConstants.GET_STEAM_FLOW_GROUP_DETAILS}`
  //          // url: `${APIConstants.GET_GROUP_DETAILS_WATER}`
  //      }).then((res) => {
  //        console.log(res)
  //        setflowGroupDetailsResData(res);
  //      });
 
    
  //  },[])
 
 
  //  useEffect(()=>{
 
  //    if(converterGroupId) {
  //      makeRequest({ 
  //        type: APIConstants.GET,  
  //        // GetFlowSteamGropeMeterDetails?GroupID=81
  //        url: `${APIConstants.GET_FLOW_NS_CONVERTER_DETAILS}?ConverterID=${converterGroupId}` 
  //      }).then((res) => {
  //        console.log(res) 
  //        setnsGetFlowConverterResData(res);
  //      });
  //    }
    
 
  //    makeRequest({ 
  //        type: APIConstants.GET,  
  //        // GetFlowSteamGropeMeterDetails?GroupID=81
  //        url: `${APIConstants.GET_FLOW_STEAM_GROUP_METER_DETAILS}?GroupID=${converterGroupId}` 
  //      }).then((res) => {
  //        console.log(res)
  //        setgetFlowSteamGroupMeterResData(res);
  //      });
  //  },[converterGroupId])

     useEffect(() => {
       if (converterId && sectionId == 1) {
         makeRequest({
           type: APIConstants.GET,
           url:`${APIConstants.TEMP_METERS}?SiteID=${converterId}&MeterType=${module??4}`,
         }).then((res) => {
           console.log(res);
           if (res && res.length > 0) {
             if (defaultLoad) {
               const firstFiveMeters = res
                 .slice(0, 5)
                 .map((meter) => meter.meteR_METERID);
   
               //console.log(res.map((meter) => meter.meterid));
               console.log(firstFiveMeters);
               setSelectedMeterIds(firstFiveMeters);
               localStorage.setItem("ConsumptionMeterIds", firstFiveMeters);
               setDefaultLoad(false);
             }
   
             setnsGetFlowConverterResData(res);
           } else {
             setSelectedMeterIds([]);
           }
         });
       }
       if (converterId && sectionId == 2) {
         makeRequest({
           type: APIConstants.POST,
           url: `${APIConstants.ELECTRICAL_GROUP_METER_DETAILS}?GroupID=${converterId}&Module=1`
         }).then((res) => {
           // //console.log(res);
           if (res && res.length > 0) {
   
             setgetFlowSteamGroupMeterResData(res);
           }
         });
       }
     }, [converterId]);
   
 
   const getFlowSectionList = (flowSectionResData && flowSectionResData) || [];
   const getFlowConverterList =
     (getFlowConverterResData && getFlowConverterResData) || [];
   const flowGroupDetailsList =
     (flowGroupDetailsResData && flowGroupDetailsResData) || [];
   const nsGetFlowConverterList =
     (nsGetFlowConverterResData && nsGetFlowConverterResData) || [];
   const getFlowSteamGroupMeterList =
     (getFlowSteamGroupMeterResData && getFlowSteamGroupMeterResData) || [];
 
 

  const fetchData = (data) => {
    console.log(data);
        if(data&&data.sectionId&&data.ConverterID&&data.FromDate&&data.ToDate&&data.meterIds){
          setLoadings(true);

          // setExcelFromDate(data.FromDate);
          // setExcelToDate(data.ToDate);
          // //console.log(data);
          makeRequest({
            type: APIConstants.GET,
          //  &SectionId=SCID&ConverterorGroupID=CGID&MeterIdsorAutoID=MAID&Parameters=Prams&ShiftID=SID&FromDate=From&ToDate=To
            url: `${APIConstants.FLOW_GET_SHIFT_REPORT}?ModuleType=${module??4}&SectionId=${data.sectionId}&ConverterorGroupID=${data.ConverterID}&MeterIdsorAutoID=${data.meterIds}&Parameters=${data.parameters}&ShiftID=${data.shift}&FromDate=${data.FromDate}&ToDate=${data.ToDate}`,
            // url:APIConstants.FLOW_GET_SHIFT_REPORT.replace("MdType",module).replace("SCID",data.sectionId).replace("CGID",data.ConverterID).replace("MAID",data.meterIds).replace("Prams",data.parameters).repeat("SID",data.shift).replace("From",data.FromDate).replace("To",data.ToDate)
          }).then((res) => {
            setLoadings(false);
            if (res && res.length > 0) {
              setConsumptionData(res);
            }
          });
      
    }
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setSkip(false);
    }, 3000);

    return () => clearTimeout(timeoutId);
  }, []);

  let formattedFromDate;
  let formattedToDate;

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const handleChangeSection = (changedValues) => {
    // console.log(changedValues,'changed values')
    setSectionId(changedValues);
    setConverterId()
    setSelectedMeterIds([]);
    if (changedValues) {
      setSectionError("");
    }
  };

  const handleChangeConverterGroup = (changedValues) => {
   
       setConverterId(changedValues);
       setConverterGroupId(changedValues);

    if (changedValues) {
      setConverterError("");
      setSelectedMeterIds([])
    }
  };
   const handleTreeChange = (values) => {
    setSelectedValues(values);
    if (values) {
      setParaError("");
    }
  };
  const handleShift=(values)=>{
        console.log(values)
        setShift(values)
  }
    const handleMeterChange = (selectedValues) => {
    setSelectedMeterIds(selectedValues);
    // //console.log(selectedValues)
    if (selectedValues) {
      setMeterError("");
    }
  };

  const onChangeFromDate = (dateString) => {
    setFromDateString(dateString);
    setFromDateObj(dateString);
    if (dateString) {
      setFromDateError("");
    }
  };

  const onChangeToDate = (dateString) => {
    setToDateString(dateString);
    setToDateObj(dateString);
    if (dateString) {
      setToDateError("");
    }
  };

  const setChartInputConverterData = () => {
    const fromDateTimeStamp = fromDateString;

    const fromDate = new Date(fromDateString || new Date());
    const toDate = new Date(toDateString || new Date());

    const fromHours = fromDate.getUTCHours();
    const fromMinutes = fromDate.getUTCMinutes();
    const fromSeconds = fromDate.getUTCSeconds();

    const toHours = toDate.getUTCHours();
    const toMinutes = toDate.getUTCMinutes();
    const toSeconds = toDate.getUTCSeconds();

    // const [fromHours, fromMinutes, fromSeconds] = time?.split(":").map(Number);
    // const [toHours, toMinutes, toseconds] = toTimeSplit?.split(":").map(Number);

    // Set the UTC hours, minutes, and seconds
    fromDate.setUTCHours(fromHours);
    fromDate.setUTCMinutes(fromMinutes);
    fromDate.setUTCSeconds(fromSeconds);

    toDate.setUTCHours(toHours);
    toDate.setUTCMinutes(toMinutes);
    toDate.setUTCSeconds(toSeconds);

    formattedFromDate = generatedISOFormatDateString(fromDate);
    formattedToDate = generatedISOFormatDateString(toDate);
 setExcelFromDate(formatDateTime(formattedFromDate))
    setExcelToDate(formatDateTime(formattedToDate))
    const ids = selectedMeterIds?.map((id) => id).join(",");

    const range = getLastDayTimeRangeIST();
    // //console.log("From:", range.from);
    // //console.log("To:", range.to);
    console.log(selectedValues,"selected")
    // console.log(selectedValues.join(','))
    console.log(shift)
   const inputData1 = {
      sectionId: Number(sectionId) || 0,
      ConverterID: Number(converterId) || 0,
      FromDate: formattedFromDate || "2023-09-21 07:15:00.000",
      ToDate: formattedToDate || "2023-09-25 07:15:00.000",
      meterIds:selectedMeterIds||[],
      parameters:selectedValues,
      shift:shift,
    };
    const inputData2 = {
      sectionId: Number(sectionId) || 0,
      ConverterID: Number(converterId) || 0,
      FromDate: range.from || "2023-09-21 07:15:00.000",
      ToDate: range.to || "2023-09-25 07:15:00.000",
      
    };
    // const queryString = inputData;
    // //console.log(inputData2);
    // //console.log(inputData1);
    // setChartConverterInput(queryString);
    //console.log(isLast24Hours);
    if (isLast24Hours) {
    //   fetchData(inputData2);
    // } else {
    }
    console.log(inputData1)
    fetchData(inputData1);
  };

  useEffect(() => {
    setChartInputConverterData()
  }, []);
  useEffect(() => {
    setChartSkip(false);
  }, [submit]);

  const validateInput = (value, label) => {
    const error = !value ? `Please select ${label}` : "";
    return error;
  };

  const handleSubmit = () => {
    const sectionError = validateInput(sectionId, "Section");
    const converterError = validateInput(converterId, "Converter");
    const fromDateError = validateInput(fromDateString, "From Date");
    const toDateError = validateInput(fromDateString, "From Date");
      const meterError = validateInput(selectedMeterIds.length, "Meter");

    setSectionError(sectionError);
    setConverterError(converterError);
    setFromDateError(fromDateError);
    setToDateError(toDateError);
          setMeterError(meterError);


    if (!sectionError && !converterError&&!fromDateError&&!toDateError&&!datesError&&!meterError) {
      onClose();
      // setSubmit(!submit);
      // if (sectionId === 1) {
      // setChartConverterInput();
      setChartInputConverterData();
      // fetchData()
      setSubmit(!submit); // This might be causing continuous re-renders
      // } else if (sectionId === 2) {
      //   // setChartGroupInput();
      //   setChartInputGroupData()
      //   // fetchData()
      //   setSubmit(!submit); // This might be causing continuous re-renders
      // }
    }
  };
  let columns = [
    {
      title: "Meter ID",
      dataIndex: "meterid",
      fixed: "left",
      minWidth: "300px",
    },
    {
      title: "Site Name",
      dataIndex: "sitename",
      fixed: "left",
      minWidth: "300px",
    },
    {
      title: "Meter Name",
      dataIndex: "metername",
      fixed: "left",
      minWidth: "300px",
    },
    {
      title: "Opening ",
      dataIndex: "opening",
      fixed: "left",
      width: "200px",
    },
    {
      title: "Closing ",
      dataIndex: "closing",
      fixed: "left",
      width: "200px",
    },
    {
      title: "Consumption",
      dataIndex: "consumption",
      fixed: "left",
      width: "200px",
    },
  ];

  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;
  const color = useSelector((state) => state.ThemeChange);
  // //console.log(color);
  useEffect(() => {
    document.documentElement.style.setProperty(
      "--date-ok-btn",
      color.themeConfig.colorPrimary
    );
    document.documentElement.style.setProperty("--date-now-btn", "#fff");
  }, [color]);

  // //console.log(consumptionData);

  const handleTimeRangeChange = () => {
    const now = dayjs();
    const fromTime = now.subtract(24, "hour");
    const fromTimeString = fromTime.format("YYYY-MM-DD HH:mm:ss");
    const toTimeString = now.format("YYYY-MM-DD HH:mm:ss");
    setFromDateObj(null);
    setToDateObj(null);
    //console.log("first");
    const range = getLastDayTimeRangeUTC();
    //console.log("From:", range.from);
    //console.log("To:", range.to);
    setFromDateString(range.from);
    setToDateString(range.to);
    setFrom(range.from);
    setTo(range.to);
    // setFromDateString(fromTimeString);
    // setToDateString(toTimeString);
    // setFrom(fromTimeString);
    // setTo(toTimeString);
  };

  const handleCheckboxChange = (e) => {
    const { checked } = e.target;
    setIsLast24Hours(checked);
    setTime(!checked);

    if (checked) {
      handleTimeRangeChange();
    } else {
      setFromDateString(null);
      setToDateString(null);
      setFromDateObj(null);
      setToDateObj(null);
    }
  };

  const getImageBufferFromUrl = async (url) => {
    const response = await fetch(url);
    return await response.arrayBuffer();
  };
// const exportToExcel = async (report, fromDate, toDate, excelImage) => {
//   const workbook = new ExcelJS.Workbook();
//   const worksheet = workbook.addWorksheet("Shift Report");

//   const formatDate = (d) =>
//     new Date(d).toLocaleDateString("en-GB");


//   const uniqueDates = [
//     ...new Set(report.map(r => formatDate(r.shiftDate)))
//   ].sort((a, b) => {
//     const [d1, m1, y1] = a.split("/").map(Number);
//     const [d2, m2, y2] = b.split("/").map(Number);
//     return new Date(y1, m1 - 1, d1) - new Date(y2, m2 - 1, d2);
//   });

//   const shiftMap = {
//     "Shift-I": "s1",
//     "Shift-II": "s2",
//     "Shift-III": "s3"
//   };

//   worksheet.mergeCells("A1:C2");

//   const logoUrl = excelImage ? excelImage : minnotra_logo;
//   const imageBuffer = await getImageBufferFromUrl(logoUrl);
//   const imageId = workbook.addImage({
//     buffer: imageBuffer,
//     extension: "png",
//   });

//   worksheet.addImage(imageId, {
//     tl: { col: 0.2, row: 0.2 },
//     ext: { width: 120, height: 35 },
//   });


//   worksheet.mergeCells("A3:H3");
//   worksheet.getCell("A3").value = "SHIFT REPORT";
//   worksheet.getCell("A3").font = { size: 14, bold: true };
//   worksheet.getCell("A3").alignment = { horizontal: "center" };

//   worksheet.mergeCells("A4:C4");
//   worksheet.mergeCells("D4:H4");
//   worksheet.getCell("A4").value = `From : ${fromDate}`;
//   worksheet.getCell("D4").value = `To : ${toDate}`;
//   worksheet.getRow(4).font = { bold: true };


//   let currentCol = 1;
//   const baseHeaders = ["Site Name", "Meter Name", "Meter ID"];
//   const rowDate = 6;
//   const rowShift = 7;
//   const rowColumn = 8;

//   baseHeaders.forEach(h => {
//     worksheet.mergeCells(rowDate, currentCol, rowColumn, currentCol);
//     worksheet.getCell(rowDate, currentCol).value = h;
//     styleHeader(worksheet.getCell(rowDate, currentCol));
//     currentCol++;
//   });

//   uniqueDates.forEach(date => {
//     const startCol = currentCol;
//     const totalCols = 11;

//     worksheet.mergeCells(rowDate, startCol, rowDate, startCol + totalCols - 1);
//     worksheet.getCell(rowDate, startCol).value = date;
//     styleHeader(worksheet.getCell(rowDate, startCol));

//     ["Shift-1", "Shift-2", "Shift-3"].forEach(shift => {
//       worksheet.mergeCells(rowShift, currentCol, rowShift, currentCol + 2);
//       worksheet.getCell(rowShift, currentCol).value = shift;
//       styleHeader(worksheet.getCell(rowShift, currentCol));

//       ["Opening", "Closing", "Consumption"].forEach(col => {
//         worksheet.getCell(rowColumn, currentCol).value = col;
//         styleHeader(worksheet.getCell(rowColumn, currentCol));
//         currentCol++;
//       });
//     });

//     worksheet.getCell(rowShift, currentCol).value = "Day Consumption";
//     worksheet.mergeCells(rowShift, currentCol, rowColumn, currentCol);
//     styleHeader(worksheet.getCell(rowShift, currentCol));
//     currentCol++;

//     worksheet.getCell(rowShift, currentCol).value = "Day Total";
//     worksheet.mergeCells(rowShift, currentCol, rowColumn, currentCol);
//     styleHeader(worksheet.getCell(rowShift, currentCol));
//     currentCol++;
//   });

//   const rowMap = {};

//   report.forEach(r => {
//     if (!rowMap[r.meterid]) {
//       rowMap[r.meterid] = {
//         sitename: r.sitename,
//         metername: r.metername,
//         meterid: r.meterid
//       };
//     }

//     const date = formatDate(r.shiftDate);
//     const shiftKey = shiftMap[r.shiftType];
//     if (!shiftKey) return;

//     rowMap[r.meterid][`${date}_${shiftKey}_open`] = r.opening ?? 0;
//     rowMap[r.meterid][`${date}_${shiftKey}_close`] = r.closing ?? 0;
//     rowMap[r.meterid][`${date}_${shiftKey}_cons`] = r.consumption ?? 0;

//     rowMap[r.meterid][`${date}_day_cons`] =
//       (rowMap[r.meterid][`${date}_day_cons`] || 0) + (r.consumption ?? 0);

//     rowMap[r.meterid][`${date}_day_total`] =
//       (rowMap[r.meterid][`${date}_day_total`] || 0) + (r.consumption ?? 0);
//   });


//   let dataRowIndex = rowColumn + 1;

//   Object.values(rowMap).forEach(row => {
//     worksheet.getRow(dataRowIndex).values = [
//       row.sitename,
//       row.metername,
//       row.meterid
//     ];

//     let colIndex = 4;

//     uniqueDates.forEach(date => {
//       ["s1", "s2", "s3"].forEach(s => {
//         worksheet.getCell(dataRowIndex, colIndex++).value = row[`${date}_${s}_open`] ?? 0;
//         worksheet.getCell(dataRowIndex, colIndex++).value = row[`${date}_${s}_close`] ?? 0;
//         worksheet.getCell(dataRowIndex, colIndex++).value = row[`${date}_${s}_cons`] ?? 0;
//       });

//       worksheet.getCell(dataRowIndex, colIndex++).value = row[`${date}_day_cons`] ?? 0;
//       worksheet.getCell(dataRowIndex, colIndex++).value = row[`${date}_day_total`] ?? 0;
//     });

//     worksheet.getRow(dataRowIndex).eachCell(styleCell);
//     dataRowIndex++;
//   });

//   worksheet.columns.forEach(col => col.width = 14);

//   const timestamp = new Date()
//     .toLocaleString("en-US", { hour12: false })
//     .replace(/[/,: ]/g, "-");

//   const buffer = await workbook.xlsx.writeBuffer();
//   saveAs(new Blob([buffer]), `Shift_Report_${timestamp}.xlsx`);
// };
const exportToExcel = async (report, fromDate, toDate) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Shift Report");


  const formatDate = (d) =>
    new Date(d).toLocaleDateString("en-GB");

  const shiftOrder = {
    "Shift-I": 1,
    "Shift-II": 2,
    "Shift-III": 3
  };

  const sortedReport = [...report].sort((a, b) => {
    const d1 = new Date(a.shiftDate);
    const d2 = new Date(b.shiftDate);
    if (d1.getTime() !== d2.getTime()) return d1 - d2;
    return (shiftOrder[a.shiftType] || 99) - (shiftOrder[b.shiftType] || 99);
  });

  const uniqueDates = [
    ...new Set(sortedReport.map(r => formatDate(r.shiftDate)))
  ].sort((a, b) => {
    const [d1, m1, y1] = a.split("/").map(Number);
    const [d2, m2, y2] = b.split("/").map(Number);
    return new Date(y1, m1 - 1, d1) - new Date(y2, m2 - 1, d2);
  });

  const shiftMap = {
    "Shift-I": "s1",
    "Shift-II": "s2",
    "Shift-III": "s3"
  };

  /* ---------- HEADER ---------- */
    worksheet.mergeCells("A1:C2");

  const logoUrl = excelImage ? excelImage : minnotra_logo;
  const imageBuffer = await getImageBufferFromUrl(logoUrl);
  const imageId = workbook.addImage({
    buffer: imageBuffer,
    extension: "png",
  });

    worksheet.addImage(imageId, {
      tl: { col: 0.2, row: 0.2 },
      ext: { width: 120, height: 35 },
    });
  worksheet.mergeCells("A3:H3");
  worksheet.getCell("A3").value = "SHIFT REPORT";
  worksheet.getCell("A3").font = { size: 14, bold: true };
  worksheet.getCell("A3").alignment = { horizontal: "center" };

  worksheet.mergeCells("A4:C4");
  worksheet.mergeCells("D4:H4");
  worksheet.getCell("A4").value = `From : ${fromDate}`;
  worksheet.getCell("D4").value = `To : ${toDate}`;
  worksheet.getRow(4).font = { bold: true };

  let currentCol = 1;
  const baseHeaders = ["Site Name", "Meter Name", "Meter ID"];
  const rowDate = 6;
  const rowShift = 7;
  const rowColumn = 8;

  baseHeaders.forEach(h => {
    worksheet.mergeCells(rowDate, currentCol, rowColumn, currentCol);
    worksheet.getCell(rowDate, currentCol).value = h;
    styleHeader(worksheet.getCell(rowDate, currentCol));
    currentCol++;
  });

  uniqueDates.forEach(date => {
    const totalCols = 10;

    worksheet.mergeCells(rowDate, currentCol, rowDate, currentCol + totalCols - 1);
    worksheet.getCell(rowDate, currentCol).value = date;
    styleHeader(worksheet.getCell(rowDate, currentCol));

    ["Shift-1", "Shift-2", "Shift-3"].forEach(shift => {
      worksheet.mergeCells(rowShift, currentCol, rowShift, currentCol + 2);
      worksheet.getCell(rowShift, currentCol).value = shift;
      styleHeader(worksheet.getCell(rowShift, currentCol));

      ["Opening", "Closing", "Consumption"].forEach(col => {
        worksheet.getCell(rowColumn, currentCol).value = col;
        styleHeader(worksheet.getCell(rowColumn, currentCol));
        currentCol++;
      });
    });

    worksheet.mergeCells(rowShift, currentCol, rowColumn, currentCol);
    worksheet.getCell(rowShift, currentCol).value = "Day Consumption";
    styleHeader(worksheet.getCell(rowShift, currentCol));
    currentCol++;


  });

  /* ---------- ADD FINAL COLUMN HEADER (ONLY ADD) ---------- */
  worksheet.mergeCells(rowDate, currentCol, rowColumn, currentCol);
  worksheet.getCell(rowDate, currentCol).value = "Total Consumption";
  styleHeader(worksheet.getCell(rowDate, currentCol));
  currentCol++;

  /* ---------- BUILD DATA ---------- */
  const rowMap = {};

  sortedReport.forEach(r => {
    if (!rowMap[r.meterid]) {
      rowMap[r.meterid] = {
        sitename: r.sitename,
        metername: r.metername,
        meterid: r.meterid,
        total_consumption: 0
      };
    }

    const date = formatDate(r.shiftDate);
    const shiftKey = shiftMap[r.shiftType];
    if (!shiftKey) return;

    rowMap[r.meterid][`${date}_${shiftKey}_open`] = r.opening ?? 0;
    rowMap[r.meterid][`${date}_${shiftKey}_close`] = r.closing ?? 0;
    rowMap[r.meterid][`${date}_${shiftKey}_cons`] = r.consumption ?? 0;

    rowMap[r.meterid][`${date}_day_cons`] =
      (rowMap[r.meterid][`${date}_day_cons`] || 0) + (r.consumption ?? 0);

    rowMap[r.meterid].total_consumption += r.consumption ?? 0;
  });

  /* ---------- WRITE ROWS ---------- */
  let dataRowIndex = rowColumn + 1;

  Object.values(rowMap).forEach(row => {
    worksheet.getRow(dataRowIndex).values = [
      row.sitename,
      row.metername,
      row.meterid
    ];

    let colIndex = 4;

    uniqueDates.forEach(date => {
      ["s1", "s2", "s3"].forEach(s => {
        worksheet.getCell(dataRowIndex, colIndex++).value = row[`${date}_${s}_open`] ?? 0;
        worksheet.getCell(dataRowIndex, colIndex++).value = row[`${date}_${s}_close`] ?? 0;
        worksheet.getCell(dataRowIndex, colIndex++).value = row[`${date}_${s}_cons`] ?? 0;
      });

      worksheet.getCell(dataRowIndex, colIndex++).value = row[`${date}_day_cons`] ?? 0;
      // worksheet.getCell(dataRowIndex, colIndex++).value = row[`${date}_day_total`] ?? 0;
    });

    worksheet.getCell(dataRowIndex, colIndex++).value =
      row.total_consumption ?? 0;

    worksheet.getRow(dataRowIndex).eachCell(styleCell);
    dataRowIndex++;
  });

  /* ---------- TOTAL ROW ---------- */
  const totalRow = worksheet.getRow(dataRowIndex);
  totalRow.getCell(2).value = "TOTAL";
  totalRow.font = { bold: true };

  let totalColIndex = 4;

  uniqueDates.forEach(date => {
    totalColIndex += 9;

    totalRow.getCell(totalColIndex).value = Object.values(rowMap)
      .reduce((s, r) => s + (r[`${date}_day_cons`] || 0), 0);
    totalColIndex++;

    // totalRow.getCell(totalColIndex).value = Object.values(rowMap)
    //   .reduce((s, r) => s + (r[`${date}_day_total`] || 0), 0);
    // totalColIndex++;
  });

  totalRow.getCell(totalColIndex).value = Object.values(rowMap)
    .reduce((s, r) => s + (r.total_consumption || 0), 0);

  totalRow.eachCell(styleCell);

  worksheet.columns.forEach(col => col.width = 14);

  // const buffer = await workbook.xlsx.writeBuffer();
  const timestamp = new Date()
    .toLocaleString("en-US", { hour12: false })
    .replace(/[/,: ]/g, "-");

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), `Shift_Report_${timestamp}.xlsx`);
};


const styleHeader = (cell) => {
  cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
  cell.alignment = { horizontal: "center", vertical: "middle" };
  cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF00B050" } };
  cell.border = {
    top: { style: "thin" },
    bottom: { style: "thin" },
    left: { style: "thin" },
    right: { style: "thin" }
  };
};

const styleCell = (cell) => {
  cell.border = {
    top: { style: "thin" },
    bottom: { style: "thin" },
    left: { style: "thin" },
    right: { style: "thin" }
  };
};


  const today = dayjs();
  const startOfWeek = dayjs().startOf("week").startOf("day"); 
  const endOfWeek = dayjs().endOf("week").startOf("day");     
  
  const startOfLastWeek = dayjs().subtract(1, "week").startOf("week").startOf("day"); // Previous Sunday 12:00 AM
  const endOfLastWeek = dayjs().subtract(1, "week").endOf("week").startOf("day");     // Previous Saturday 12:00 AM
  
  const startOfMonth = dayjs().startOf("month").startOf("day");     // 1st of this month 12:00 AM
  const endOfMonth = dayjs().endOf("month").startOf("day");         // Last of this month 12:00 AM
  
  const startOfLastMonth = dayjs().subtract(1, "month").startOf("month").startOf("day");
  const endOfLastMonth = dayjs().subtract(1, "month").endOf("month").startOf("day");
  
  const rangePresets = [
    { label: "Yesterday", value: [today.subtract(1, "day").startOf("day"), today.startOf("day")] },
    { label: "This Week", value: [startOfWeek, endOfWeek] },
    { label: "Last Week", value: [startOfLastWeek, endOfLastWeek] },
    { label: "This Month", value: [startOfMonth, endOfMonth] },
    { label: "Last Month", value: [startOfLastMonth, endOfLastMonth] },
    { label: "Last 7 Days", value: [dayjs().subtract(7, "day").startOf("day"), today.startOf("day")] },
    { label: "Last 15 Days", value: [dayjs().subtract(15, "day").startOf("day"), today.startOf("day")] },
    { label: "Last 30 Days", value: [dayjs().subtract(30, "day").startOf("day"), today.startOf("day")] },
    // { label: "Last 90 Days", value: [dayjs().subtract(90, "day").startOf("day"), today.startOf("day")] },
  ];
const handleDateChange = (value) => {
  if (!value || !value[0] || !value[1]) {
    setDatesError("Please select a date range");
    setValue(null);
    return;
  }

  const diff = Math.abs(value[1].diff(value[0], "day"));

  if (diff > MAX_DAYS) {
    setDatesError(`Date range cannot exceed ${MAX_DAYS} days`);
    return;
  }

  setDatesError(null);

  setValue(value);
  onChangeFromDate(value[0].format("YYYY-MM-DD HH:mm:ss"));
  onChangeToDate(value[1].format("YYYY-MM-DD HH:mm:ss"));
};

const handleCalendarChange = (dates) => {
  setTempDates(dates);

  if (!dates || !dates[0] || !dates[1]) return;

  const diff = Math.abs(dates[1].diff(dates[0], "day"));

  if (diff > MAX_DAYS) {
    setDatesError(`Date range cannot exceed ${MAX_DAYS} days`);
    message.error(`Date range cannot exceed ${MAX_DAYS} days`);
  } else {
    setDatesError(null);
  }
};

const disabledDate = (current) => {
  if (!tempDates || !tempDates[0]) return false;

  const diff = Math.abs(current.diff(tempDates[0], "day"));

  return diff > MAX_DAYS;
};

    const handleModuleChange = (value) => {
    console.log(value);
    setModule(value);
    setSectionId([]);
    setConverterId(null);
    setSelectedMeterIds([]);
  };

  return (
    <div className=" rounded-md w-auto p-4">
      <div className="flex justify-between items-center px-0 pb-0">
        <div className="text-3xl">
          <p
            className={` dark ${isdarkMode ? "darkfont" : "whitemode"} text-center pb-0  ml-0 font-[500] tracking-[1px]`}
          >
            SHIFT REPORT
          </p>
        </div>
        <div className="flex my-2 gap-2">
          <Button
            role="primary"
            size="large"
            className="flex justify-center items-center secondary-btn"
            style={{
              "--secondary-color": color.themeConfig.secondaryColor,
              "--primary-color": color.themeConfig.colorPrimary,
            }}
            onClick={() => setOpen(!open)}
          >
            <FilterOutlined /> Filter
          </Button>
          <Button
            size="large"
            type="primary"
            disabled={consumptionData.length === 0}
            onClick={() =>
              exportToExcel(consumptionData, excelFromDate, excelToDate)
            }
          >
            Create Excel
          </Button>
        </div>
      </div>
      {!loadings && !loading && consumptionData.length > 0 && (
        <div className={`m-2`}>
          {/* <TableComponentReport report={consumptionData} meters={columns} /> */}
          <TableComponentShiftReport report={consumptionData}/>
        </div>
      ) 
      
    }
    {!loadings && !loading && consumptionData.length === 0 &&
       (
        <div
          className={`${!isdarkMode ? "text-black " : "text-white "} text-center`}
        >
          <Empty open={open} setOpen={setOpen} isdarkMode={isdarkMode} />
        </div>
      )}
    {loading && (
                <Skeleton active paragraph={{ rows: 6 }} />
      )}

      <CustomDrawer
        title="Close"
        showDrawer={showDrawer}
        open={open}
        onClose={onClose}
      >
        <div className="flex flex-col space-y-2">
            <CustomSelect
            label="Module :"
            options={moduleList}
            onSelect={handleModuleChange}
            valueKey={"moduleId"}
            nameKey={"moduleName"}
            selectedValues={module}
          />
              <CustomSelect
            label="Section:"
            options={getFlowSectionList}
            onSelect={handleChangeSection}
            valueKey="sectionID"
            nameKey="sectionName"
            selectedValues={sectionId}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {sectionError}
          </small>
          <CustomSelect
            label="Converter / Group:"
            options={
              sectionId === 1 ? getFlowConverterList : flowGroupDetailsList
            }
            onSelect={handleChangeConverterGroup}
            valueKey={sectionId === 1 ? "sitE_ID" : "groupID"}
            nameKey={sectionId === 1 ? "sitename" : "department"}
            selectedValues={converterId}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {converterError}
          </small>
          
        <SteamTreeSelectCustomWithSelectAll
            label="Meters:"
            data={
              sectionId === 1
                ? nsGetFlowConverterResData
                : flowGroupDetailsList
            }
            idKey={sectionId === 1 ? "meteR_METERID" : "meteR_METERID"}
            valueKey={sectionId === 1 ? "meteR_METERID" : "meteR_METERID"}
            nameKey={sectionId === 1 ? "metername" : "metername"}
            selectedValues={selectedMeterIds}
            setSelectedValues={setSelectedMeterIds}
            onSelect={handleMeterChange}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {meterError}
          </small>
                 <SteamTreeSelectCustomWithSelectAll
                      label="Parameters:"
                      data={parameter}
                      idKey="parameterID"
                      nameKey="parameterName"
                      valueKey="parameterName"
                      selectedValues={selectedValues}
                      onSelect={handleTreeChange}
                          isMultipleSelect={false}
              isSelectAll={false}
                    />
                    <small className="text-red-500 font-bold ml-[150px]">
                      {paraError}
                    </small>

                            {/* <CustomSelect
            label="Shift:"
            options={shiftTimings}
            onSelect={handleShift}
            valueKey={ "autoID" }
            nameKey={"shiftType"}
              selectedValues={shift}
          /> */}
          <small className="text-red-500 font-bold ml-[150px]">
            {converterError}
          </small>
          <div className="mt-2 flex">
            <label className="pr-3 w-32 text-left"> Date:</label>
           <RangePicker
              value={value}
               onCalendarChange={handleCalendarChange}
              onChange={handleDateChange}
                disabledDate={disabledDate}  
              popupClassName="custom-picker"
              presets={rangePresets}
              
              format="YYYY-MM-DD HH:mm:ss"
              showTime={{ format: "HH:mm:ss" }}
              className={`w-80 ml-0 shadow-lg rounded-3xl  ${
                isdarkMode
                  ? "customRangePicker-dark  text-white"
                  : "customRangePicker-light text-black"
              }`}
              panelRender={(originalPanel) => {
                if (!showCalendar) {
                  return (
                    <div
                      className={`${
                        isdarkMode ? "bg-[#1a1a1a]" : "bg-white"
                      } flex flex-col gap-1 p-2 w-44 rounded`}
                    >
                      {rangePresets.map((preset) => (
                        <div
                          key={preset.label}
                          onClick={() => handleDateChange(preset.value)}
                          className={`cursor-pointer px-2 py-1 rounded ${
                            isdarkMode
                              ? "text-white hover:bg-gray-700"
                              : "text-black hover:bg-gray-200"
                          }`}
                        >
                          {preset.label}
                        </div>
                      ))}
                      <button
                        onClick={() => setShowCalendar(true)}
                        className={`mt-2 px-2 py-1 rounded  border text-center ${
                          isdarkMode
                            ? "bg-[#1a1a1a] border-white text-white hover:bg-gray-700"
                            : "bg-white border-black text-black hover:bg-gray-200"
                        }`}
                      >
                        Custom Dates
                      </button>
                    </div>
                  );
                }
                return originalPanel;
              }}
              onOpenChange={(open) => {
                if (!open) setShowCalendar(false);
              }}
            />
          </div>
              <small className="text-red-500 font-bold ml-[150px]">
            {datesError}
          </small>
         
        </div>

        <div className="flex justify-center mt-4">
          {/* <ConfigProvider
            theme={{
              token: {
                colorPrimary: "#52c41a", // Green color
                colorPrimaryHover: "#40a700", // Darker green on hover
                colorBgContainer: isdarkMode === "dark" ? "#292c35" : "#f6ffed",
                colorTextBase: isdarkMode === "dark" ? "#fff" : "#000",
              },
            }}
          >
          </ConfigProvider> */}
          <Button
            type={isdarkMode ? "" : "primary"}
            onClick={() => {
              handleSubmit();
            }}
          >
            Search
          </Button>
        </div>
      </CustomDrawer>
      <style>
        {`
          .custom-picker .ant-picker-ok .ant-btn{
            background-color: var(--date-ok-btn) !important;
            border-color: var(--date-ok-btn) !important;
            color: white !important;
          }
          .custom-picker .ant-picker-ok .ant-btn:hover {
            background-color: var(--date-ok-btn) !important;
            border-color: #d9363e !important;
          }
          .custom-picker .ant-picker-now .ant-picker-now-btn {
            color: var(--date-ok-btn) !important;
          }
           .custom-picker .anticon-swap-right, .anticon-calendar{
            // background-color: red !important;
            color: var(--date-ok-btn) !important;
          }
        `}
      </style>
    </div>
  );
};

export default ShiftReportFlow;
